module.exports = __webpack_public_path__ + "static/media/vf_mshirts_core.b363b24f.svg";